import axios from "axios";
import React from "react";
import GetServerAddress from "../../../../functions/GetServerAddress";

export function Request_Letter(
  Attendee,
  Letter,
  Emails,
  BCCEmails,
  newNote,
  logoutConsultant
) {
  // Choose fields like this:
  // { item: 1, status: 1, _id: 0 }

  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/consultant/Request_Letter",
        {
          Attendee: Attendee,
          Letter: Letter,
          Emails: Emails,
          newNote: newNote,
          BCCEmails: BCCEmails,
          //   EC_ID: localStorage.getItem("Consultant_id"),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("ConsultantToken")}`, // Include the JWT token in the
            username: localStorage.getItem("Consultant_id"),
            activitylog: "Yes",
            aboutid: Attendee._id,
          },
        }
      );
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logoutConsultant();

        return; // Stop further execution in case of invalid auth token
      }
      console.log("Response Data: ", response);
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  fetchData();
} // Empty dependency array means this effect runs only once
